module.exports = __webpack_public_path__ + "h5assets/img/collabs-level-company-en@2x.cab9cc9.png";